import { Chart } from './Chart'
import type { ApexOptions } from 'apexcharts'

class PieChart extends Chart {
  constructor() {
    super()
  }

  options = {
    ...this.options,
    chart: {
      ...this.options.chart,
      type: 'donut'
    },
    series: [],
    colors: [],
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      fontSize: '16px',
      formatter: function (seriesName, opts) {
        return `<span class='font-medium pl-2 pr-4'>${seriesName} : ${opts.w.globals.series[opts.seriesIndex]}</span>`
      },
      markers: {
        radius: 0,
        width: 15,
        height: 15
      }
    },
    plotOptions: {
      pie: {
        customScale: 0.8,
        donut: {
          size: '40%'
        }
      }
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.85
        }
      }
    }
  } as ApexOptions

  setColor(color: string[]): void {
    this.options.colors = color
  }

  setSeries(series: []): void {
    this.options.series = series
  }

  setLabels(labels: string[]): void {
    this.options = {
      ...this.options,
      labels: labels,
      ...{
        xaxis: {
          ...this.options.xaxis,
          categories: labels
        }
      }
    }
  }
}

export { PieChart }
